import aoflModules from 'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min';
import aofljs from 'js/aofl-js/0.8.0/app/aofl';
import states from './config/state-routes-com';
import statesAnalyticsData from './config/states-analytics-data-com';
import getResourceEnumerateConfig from './config/resource-enumerate';
import riqJS from './riq-js/index';
import css from '../css/index-com.css'; // eslint-disable-line no-unused-vars
import {isMobile} from '@aoflmkt/is-mobile';

function main(
  aofljs,
  states,
  aoflModules,
  getResourceEnumerateConfig,
  sharedBundle
) {
  var token;
  var deviceId;
  var deepLinkRedirect;
  var resourceEnumerateConfig;
  var urlToken;

  var _getDeepLinkRedirect = function _getDeepLinkRedirect() {
    var deepLinkRedirect = localStorage.getItem('deepLinkRedirect');
    if (deepLinkRedirect) {
      // need to remove the redirect so the user can refresh the page
      localStorage.removeItem('deepLinkRedirect');
    }
    return deepLinkRedirect;
  };

  aoflModules.ready
    .then(function() {
      token =
        sharedBundle.cookieService.get('token') ||
        localStorage.getItem('riqAuthToken');
      // Mobile App redirect to pages with token in the url, grab it and clean the url afterwards when a token is in the url
      urlToken = new URLSearchParams(window.location.search).get('token');
      // Url token should never override an existing token otherwise
      // we risk having a security exploit that can be used to logout signed in users
      if (urlToken && !token) {
        token = urlToken;
      }

      if (urlToken) {
        window.history.replaceState(
          null,
          window.title,
          location.pathname[location.pathname.length - 1] === '/'
            ? location.pathname + location.hash
            : location.pathname + '/' + location.hash
        );
      }

      deviceId = sharedBundle.cookieService.get('deviceId');
      deepLinkRedirect = _getDeepLinkRedirect();
      if (!deviceId) {
        deviceId = aoflModules.uuid();
        // @to-do notify Marketing code somehow that deviceId is being set by private app.
        localStorage.setItem('readingIqDeviceId', deviceId);
      }
      var requestOptions = sharedBundle.riqApiFormatter.pack({
        token: token,
        deviceId: deviceId,
        args: []
      });
      resourceEnumerateConfig = getResourceEnumerateConfig(requestOptions);
      return aoflModules.resourceEnumerate.init(resourceEnumerateConfig);
    })
    .then(function onResourceEnumerate() {
      var statesRotation = states.getStates(aofljsConfig.applicationRootPath);
      var options = Object.assign({}, aofljsConfig, {
        states: statesRotation,
        env: aoflModules.resourceEnumerate.environment,
        environmentsEnum: aoflModules.EnvironmentTypeEnumerate
      });
      return aofljs(options, aoflModules.ready);
    })
    .then(function aofljsReady(appData) {
      appData.app.registerConstant('aoflModules', aoflModules);
      appData.app.registerConstant('statesAnalyticsData', statesAnalyticsData);
      appData.app.registerConstant(
        'resourceEnumerateConfig',
        resourceEnumerateConfig
      );
      let debModulePromise = Promise.resolve();
      if (aofljsConfig.applicationDebug) {
        debModulePromise = import(
          /* webpackChunkName: "debug-menu" */ './debug-menu/index'
        ).then(startDebugMenu => {
          startDebugMenu.default(appData.injector);
        });
      }
      return debModulePromise.then(
        // eslint-disable-next-line
        _ =>
          appData.injector
            .get('riqInitService')
            .init(token, deviceId, deepLinkRedirect, urlToken)
      );
    })
    .catch(function(_err) {
      // eslint-disable-next-line no-console
      console.error(_err);

      if (isMobile.any) {
        // eslint-disable-next-line
        if (!aofljsConfig.applicationDebug) {
          window.location.href = '/download-app';
        } else {
          console.error('/download-app redirect');
        }
      }
      if (typeof aofljsConfig.globalErrorHandler === 'function') {
        aofljsConfig.globalErrorHandler(_err);
      }
    });
}

main(aofljs, states, aoflModules, getResourceEnumerateConfig, riqJS);
